import { config } from './config/index';
const firebaseConfig = config.firebase;

export { firebaseConfig };
